function cargarElementos(content){
  if (Boolean(content)){
    let positionProduct = content.getBoundingClientRect();
    let divElement = document.createElement("div");
    divElement.style.height = `${positionProduct.height}px`;
    //divElement.classList.add('product-info__block-parent')
    content.appendChild(divElement);
  }
}
function escucharScrool(content) {
  let positionProduct = content.getBoundingClientRect();
  let divHijo = content.querySelector('.product-info__block-list');
  if (positionProduct.bottom < 0) {
  /*  if (!divHijo.classList.contains('product-info__fixed-bottom')) {
       //divHijo.classList.add('product-info__fixed-bottom'); 
    }
  }else{
    if (divHijo.classList.contains('product-info__fixed-bottom')) {
       //divHijo.classList.remove('product-info__fixed-bottom');
    }
  }*/
}
}

document.addEventListener('variant:change', e=>{
  let stickybtn = document.querySelector('.product-sticky-bar .buy-buttons .button');

  let verifybtn = document.querySelector("#newBtnSticky");
  if(Boolean(verifybtn)){
    verifybtn.remove();
    document.querySelector('.stickyvariants').classList.remove('hidden');
  }

  if(e.detail.variant.available){
    stickybtn.classList.remove("hidden");
    stickybtn.innerHTML = window.themeVariables.strings.addToCartButton;
    stickybtn.disabled = false;
    let gBackInStockBtnSticky = document.querySelector('.product-sticky-bar .gBackInStockBtnSticky');
    if(Boolean(gBackInStockBtnSticky)){
      gBackInStockBtnSticky.classList.add("hidden");
      gBackInStockBtnSticky.setAttribute("onclick", "");
      gBackInStockBtnSticky.addEventListener("click", e=> e.preventDefault());
    }
  }else{

    let verifybtn = document.querySelector("#newBtnSticky");
    if(Boolean(verifybtn)){
      verifybtn.remove();
      document.querySelector('.stickyvariants').classList.remove('hidden');
      let globoStickyPlaceholder = document.querySelector('.stickyvariants #Globo-Back-In-Stock');
      if(Boolean(globoStickyPlaceholder)){
        globoStickyPlaceholder.classList.add('hidden');
      }
    }
    stickybtn.classList.add("hidden");
    stickybtn.innerHTML = window.themeVariables.strings.soldOutButton;
    stickybtn.disabled = true;
  }
});

function getVariant(params) {
  //params
}

function optionsDisabled() {
  const elementjson = document.querySelector('script[data-product-json]');
  const productjson = JSON.parse(elementjson.innerHTML);

  const findVariantByOptions = (variants, { option1, option2 }) => {
    if(option2){
      return variants.find((variant) => variant.option1 === option1 && variant.option2 === option2);
    }else{
      return variants.find((variant) => variant.option1 === option1);
    }
  };
  
  const variants = productjson.variants;
  /* variants.forEach(variant=>{
    if(variant.available == true){
      //console.log("variant true");
      //console.log(variant);
    }else{
      let SizeSwatch = document.querySelectorAll(".sticky-options .block-swatch");
      let variantsunavailable = Array.from(SizeSwatch).find(item => item.textContent == variant.title);
      if(variantsunavailable){
        variantsunavailable.classList.add("unavailable");
      }
      
    }
  });
  */

  const optionInputEls1 = document.querySelectorAll('.variant-picker input[name^="option1"]');
  const optionInputEls2 = document.querySelectorAll('.variant-picker input[name^="option2"]');
  //const optionInputEls = document.querySelectorAll('.variant-picker input[name^="option2"]');

  optionInputEls1.forEach((optionInputEl) => {
    const optionIndex = Number(optionInputEl.name.split('option')[1]);
    const optionInputCheck = document.querySelectorAll('.variant-picker input[name^="option"]:checked');
    let optsin = {};
    let opts = Array.from(optionInputEl).map((inputcheck, index)=>{
      optsin[`option${index + 1}`] = inputcheck.value;
      return inputcheck.value;
    });

    const foundVariant = findVariantByOptions(productjson.variants, optsin);
    // Only check option inputs that are not of the same group as the changed option
    if (!foundVariant || !foundVariant.available) {
      //optionInputEl.nextElementSibling.classList.add('opt-sold-out');
    } else {
      //optionInputEl.nextElementSibling.classList.remove('opt-sold-out');
    }


  });
}

window.addEventListener("DOMContentLoaded", (e) => {

  ///optionsDisabled();

  /* Artdinamica - Consulta de ip/country
var r = new XMLHttpRequest();
r.onreadystatechange = function(data) {
   if (this.readyState == 4 && this.status == 200) {
      var contact = JSON.parse(this.responseText);
      console.log(contact.location.country);

      // Verificar si el país es España (ES)
      if (contact.location.country === 'ES') {
         // Si el cliente está en la versión inglesa, redirigir a la versión española
         if (window.location.pathname.indexOf('/en') !== -1) {
            window.location.replace("/");
         }
      } else {
         // Si el cliente no está en España y no está en la versión inglesa, redirigir a la versión inglesa
         if (window.location.pathname.indexOf('/en') === -1) {
            window.location.replace("/en");
         }
      }
   }
}
r.open("GET", 'https://geo.ipify.org/api/v2/country?apiKey=at_MUQO7xoRGATTRkwwcuoWuBUktNlFc', true);
r.send();
FIN Artdinamica - Consulta de ip/country */
  
/* Comprobar visita de Google */
var agent = window.navigator.userAgent;
const botUserAgentsArray = [
    'googlebot',
    'bingbot',
    'speed insights',
    'chrome-lighthouse',
    'adsbot-google',
    'adsbot-google-mobile',
    'linkedinbot',
    'mediapartners-google',
    'lighthouse',
    'insights',
];

var isBotUserAgent = false;
for (var j = 0; j < botUserAgentsArray.length; j++) {
    if (agent.toLowerCase().indexOf(botUserAgentsArray[j].toLowerCase()) !== -1) {
        isBotUserAgent = true;
        break;
    }
}

/* Si no es Google Bot */
if (!isBotUserAgent) {
    var r = new XMLHttpRequest();
    r.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
            var contact = JSON.parse(this.responseText);
            var country = contact.location.country;
            var currentPath = window.location.pathname;
            console.log(contact.location.country);

            var euCountries = ['FR', 'DE', 'NL', 'BE', 'LU', 'AT', 'DK', 'SE', 'FI', 'IE', 'GR', 'CY', 'MT', 'EE', 'LV', 'LT', 'PL', 'CZ', 'SK', 'HU', 'SI', 'HR', 'BG', 'RO'];
            var isEuCountry = euCountries.includes(country);

            // Bandera para indicar si ya se ha redirigido al usuario
            var redirected = false;

            if (country === 'US' || country === 'MX') {
                window.location.replace("https://theextremecollectionusa.com/");
                redirected = true;
            } else if (country === 'GB') {
                window.location.replace("https://www.wolfandbadger.com/us/designers/the-extreme-collection/");
                redirected = true;
            } else if (country === 'ES') {
                if (currentPath.startsWith('/en-int') || currentPath.startsWith('/en-eu') || currentPath.startsWith('/it-eu') || currentPath.startsWith('/es-eu') || currentPath.startsWith('/es-int')) {
                    window.location.replace('/');
                    redirected = true;
                } 
            } else if (country === 'PT') {
                if (!currentPath.startsWith('/es-pt')) {
                    var newPath = '/es-pt' + currentPath;
                    window.location.replace(newPath);
                    redirected = true;
                }
            } else if (country === 'IT') {
              
                // if (!currentPath.startsWith('/it-eu') && !currentPath.startsWith('/es-eu') && !currentPath.startsWith('/en-eu')) {
                //     var newPath = currentPath.startsWith('/en') ? '/it-eu' + currentPath.substring(3) : '/it-eu' + currentPath;
                //     window.location.replace(newPath);
                //     redirected = true;
                // }
                  window.location.replace("https://int.theextremecollection.com/");
                        redirected = true;
            } else if (isEuCountry) {
                // if (!currentPath.startsWith('/en-eu') && !currentPath.startsWith('/it-eu') && !currentPath.startsWith('/es-eu')) {
                //     var newPath = currentPath.startsWith('/en') ? '/en-eu' + currentPath.substring(3) : '/en-eu' + currentPath;
                //     window.location.replace(newPath);
                //     redirected = true;
                // }
                window.location.replace("https://int.theextremecollection.com/");
                        redirected = true;
            } else {
                /*// Verificar para internacional si no empieza con /es-int o /en-int
                if (!currentPath.startsWith('/en-int') && !currentPath.startsWith('/es-int')) {
                    var newPath = currentPath.startsWith('/en') ? '/en-int' + currentPath.substring(3) : '/en-int' + currentPath;
                    window.location.replace(newPath);
                    redirected = true;
                }*/
              // Enviar a la tienda de int
                    if (currentPath === '/') {
                        window.location.replace("https://int.theextremecollection.com/");
                        redirected = true;
                    } else if (currentPath === '/en') {
                        window.location.replace("https://int.theextremecollection.com/en");
                        redirected = true;
                    } else {
                        window.location.replace("https://int.theextremecollection.com/");
                        redirected = true;
                    }
              
            }

            // Detener la ejecución del script si ya se ha redirigido al usuario
            if (redirected) {
                return;
            }
        }
    };
    r.open("GET", 'https://geo.ipify.org/api/v2/country?apiKey=at_MUQO7xoRGATTRkwwcuoWuBUktNlFc', true);
    r.send();
}





    
  let stickyopts = document.querySelectorAll(`.sticky-options .block-swatch`);
  stickyopts.forEach(opt=>{
    opt.addEventListener("click", e=>{
      let siblings = [...opt.parentNode.children].filter((child) => child !== opt);
      siblings.forEach(sibling=>sibling.classList.remove("active"));
      opt.classList.add("active");
    });
  });
  let contentProduct = document.querySelector(`safe-sticky.product-info`);
  if (Boolean(contentProduct)) {
    cargarElementos(contentProduct);
    escucharScrool(contentProduct);
  }  

  const targetForm = document.querySelector(".product-info__block-item[data-block-type='buy-buttons'] .shopify-product-form");
  if(Boolean(targetForm)) {
    // subtree:true porque el botón de Klaviyo (#klaviyo-bis-button-container) se
    // inyecta un par de niveles más adentro que el de Globo (que se añadía como
    // hijo directo del form), así que con subtree:false no se llegaba a detectar.
    let configf = { attributes: false, childList: true, subtree: true };
    let callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        // Reacciona tanto a que se añada el botón (Globo/Klaviyo lo inyecta)
        // como a que se quite (la variante vuelve a estar disponible y
        // Klaviyo retira su propio botón) -- si solo miramos altas, el clon
        // de la barra fija se queda "colgado" al recuperar stock.
        if (mutation.type === "childList") {
          let verifybtn2 = document.querySelector("#newBtnSticky");
          if(Boolean(verifybtn2)){
            verifybtn2.remove();
          }

          // Botón real de "aviso de reposición": el de Globo si sigue activo, o
          // si no, el que inyecta Klaviyo una vez enganchado. Se reutiliza el
          // mismo mecanismo de espejo en la barra fija para los dos, así no se
          // pierde este comportamiento al retirar Globo.
          let realBisBtn = document.querySelector('#Globo-Back-In-Stock .gBackInStockBtn');
          if(!Boolean(realBisBtn)){
            const klContainer = document.getElementById('klaviyo-bis-button-container');
            if(Boolean(klContainer) && klContainer.children.length > 0){
              realBisBtn = klContainer.querySelector('button, a') || klContainer;
            }
          }

          if(Boolean(realBisBtn)){
            document.querySelector('.stickyvariants').classList.add('hidden');
            console.log('backinstock');

            const newBtnSticky = document.createElement("div");
            newBtnSticky.innerHTML = realBisBtn.textContent;
            newBtnSticky.classList.add("button", "w-full");
            newBtnSticky.setAttribute("id","newBtnSticky");
            newBtnSticky.addEventListener("click", e=> {
              realBisBtn.click();
            });
            if(Boolean(document.querySelector('.product-sticky-bar'))){
              document.querySelector('.product-sticky-bar').appendChild(newBtnSticky);
              let stickybtn = document.querySelector('.product-sticky-bar .buy-buttons .button');
              let stickyvariants = document.querySelector('.product-sticky-bar .stickyvariants');
              stickybtn.classList.add("hidden");
              stickyvariants.classList.add("hidden");

            }

          } else {
            document.querySelector('.stickyvariants').classList.remove('hidden');
            let globoStickyPlaceholder = document.querySelector('.stickyvariants #Globo-Back-In-Stock');
            if(Boolean(globoStickyPlaceholder)){
              globoStickyPlaceholder.classList.add('hidden');
            }
            // Ya no hay botón de reposición real (la variante volvió a estar
            // disponible) -- restauramos el botón normal de la barra fija.
            let stickybtnRestore = document.querySelector('.product-sticky-bar .buy-buttons .button');
            if(Boolean(stickybtnRestore)){
              stickybtnRestore.classList.remove('hidden');
            }
          }
        }
      }
    };
    let observer = new MutationObserver(callback);
    observer.observe(targetForm, configf);
  }

/*
window.addEventListener('scroll',(e) => {
  let contentProduct = document.querySelector(`safe-sticky.product-info`);
  escucharScrool(contentProduct);
});
*/
const targetNode = document.querySelector(".product-info__block-item .variant-picker");
if (Boolean(targetNode)) {
  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        console.log("A child node has been added or removed.");
      } else if (mutation.type === "attributes") {
        console.log(`The ${mutation.attributeName} attribute was modified.`);
      }
    }
  };
  
  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);
  
  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);  
}
});

// Artdinamica. Listado de tallas en colecciones (Delegación de eventos)
document.addEventListener("DOMContentLoaded", function() {
  // Agregamos el evento de click a un contenedor común que envuelva todos los productos (puede ser body o un contenedor más específico)
  document.body.addEventListener("click", function(event) {
    // Verificamos si el clic fue en un elemento con la clase 'size-toggle-btn'
    if (event.target.classList.contains("size-toggle-btn")) {
      var sizeToggleBtn = event.target;
      var sizesDropdown = sizeToggleBtn.nextElementSibling; // Encuentra el siguiente elemento (el dropdown) de este botón

      // Alternar la visibilidad del dropdown de tallas o productos relacionados
      if (sizesDropdown.style.display === "none" || sizesDropdown.style.display === "") {
        sizesDropdown.style.display = "block";
      } else {
        sizesDropdown.style.display = "none";
      }

      // Cerrar otros dropdowns que estén abiertos
      document.querySelectorAll(".sizes-dropdown").forEach(function(dropdown) {
        if (dropdown !== sizesDropdown) {
          dropdown.style.display = "none";
        }
      });
    }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  if (typeof Ajaxinate !== "undefined" && document.getElementById("AjaxinateContainer")) {
    var endlessScroll = new Ajaxinate();
  }
});



function detectLocale() {
    // Método 1: Detectar idioma según la URL
    if (window.location.pathname.includes("/en/")) {
        return "en-BE"; // Inglés
    }

    // Método 2: Detectar idioma según el atributo <html lang="es">
    let htmlLang = document.documentElement.lang;
    if (htmlLang) {
        return htmlLang.startsWith("es") ? "es-ES" : "en-BE";
    }

    return "es-ES"; // Por defecto, español
}

function replaceAnnouncementBar() {
    console.log("🔍 Buscando el Announcement Bar...");

    let announcementCarousel = document.querySelector("#carousel-sections--20582625640783__announcement-bar");
    if (!announcementCarousel) {
        console.log("❌ No se encontró el carrusel del Announcement Bar.");
        return false;
    }

    let announcementTexts = announcementCarousel.querySelectorAll("p.prose.heading");

    announcementTexts.forEach((announcementBar) => {
        console.log("🧐 Analizando:", announcementBar.textContent.trim());

        if (announcementBar.textContent.trim() === "Prueba") {
            console.log("🔄 Reemplazando 'Prueba' con Klarna...");

            let locale = detectLocale(); // Obtener idioma

            // 📌 Ajuste del precio según el idioma
            let priceAmount = locale === "es-ES" ? "100" : "1000"; // "10" en español, "1000" en inglés

            console.log(`🌍 Idioma detectado: ${locale}`);
            console.log(`💰 Monto fijado: ${priceAmount} céntimos`);

            // Crear Klarna Placement con el idioma correcto y el ajuste del monto
            let klarnaWrapper = document.createElement("p");
            klarnaWrapper.className = announcementBar.className;
            klarnaWrapper.style.opacity = "1";
            klarnaWrapper.style.transform = "translateY(0px)";
            klarnaWrapper.classList.add("is-selected");

            let klarnaElement = document.createElement("klarna-placement");
            klarnaElement.setAttribute("data-key", "credit-promotion-auto-size");
            klarnaElement.setAttribute("data-locale", locale);
            klarnaElement.setAttribute("data-purchase-amount", priceAmount);
            klarnaElement.setAttribute("data-theme", "dark");

            klarnaWrapper.appendChild(klarnaElement);
            announcementBar.replaceWith(klarnaWrapper);

            console.log("🎉 Klarna añadido correctamente:", klarnaElement);

            // 🔥 Forzar la inicialización del Klarna SDK después del cambio
            if (window.Klarna && window.Klarna.OnSiteMessaging) {
                console.log("🔄 Recargando Klarna On-Site Messaging...");
                window.Klarna.OnSiteMessaging.init();
                window.Klarna.OnSiteMessaging.load();
            } else {
                console.log("⚠️ Klarna SDK no está disponible en window.Klarna.");
            }
        }
    });

    return announcementTexts.length > 0;
}

// Intentar reemplazar inmediatamente
if (!replaceAnnouncementBar()) {
    console.log("⏳ Elemento no encontrado, iniciando MutationObserver...");

    const observer = new MutationObserver(() => {
        console.log("🔄 MutationObserver detectó cambios en el DOM...");
        if (replaceAnnouncementBar()) {
            console.log("✅ Klarna agregado, deteniendo el Observer.");
            observer.disconnect();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

/*paginacion producto galeria*/
document.addEventListener("DOMContentLoaded", function () {
  // Solo ejecutar si pantalla es móvil (ancho <= 768px)
  if (window.innerWidth > 768) return;

  const carousel = document.querySelector('scroll-carousel');
  if (!carousel) return;

  const slides = carousel.querySelectorAll('.product-gallery__media');

  // Crear contenedor de paginación
  const paginationContainer = document.createElement('div');
  paginationContainer.className = 'carousel-pagination';
  carousel.insertAdjacentElement('afterend', paginationContainer);

  // Crear dots dinámicamente
  slides.forEach((_, index) => {
    const dot = document.createElement('div');
    dot.classList.add('carousel-dot');
    if (index === 0) dot.classList.add('active');
    dot.addEventListener('click', () => {
      carousel.scrollTo({
        left: slides[index].offsetLeft,
        behavior: "smooth"
      });
    });
    paginationContainer.appendChild(dot);
  });

  const dots = paginationContainer.querySelectorAll('.carousel-dot');

  // Actualizar dot activo al hacer scroll
  carousel.addEventListener('scroll', () => {
    const scrollPosition = carousel.scrollLeft;
    let activeIndex = 0;

    slides.forEach((slide, index) => {
      if (scrollPosition >= slide.offsetLeft - slide.offsetWidth / 2) {
        activeIndex = index;
      }
    });

    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === activeIndex);
    });
  });
});

// ─── Product Card Image Swiper ────────────────────────────────────────────
(function () {
  let SwiperLib = null;

  async function getSwiper() {
    if (SwiperLib) return SwiperLib;
    const { default: Swiper } = await import(
      'https://cdn.jsdelivr.net/npm/swiper/swiper-bundle.esm.browser.min.js'
    );
    SwiperLib = Swiper;
    return Swiper;
  }

  async function initSlider(el) {
    if (el.classList.contains('swiper-initialized')) return;
    const Swiper = await getSwiper();
    new Swiper(el, {
      loop: true,
      slidesPerView: 1,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },
    });
  }

  function observeSliders(elements) {
    elements.forEach((el) => {
      if (el.classList.contains('swiper-initialized')) return;
      const observer = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              initSlider(entry.target);
              obs.unobserve(entry.target);
            }
          });
        },
        { rootMargin: `${(el.clientHeight || 300) * 3}px`, threshold: 0 }
      );
      observer.observe(el);
    });
  }

  function watchForNewSliders() {
    new MutationObserver((mutations) => {
      const found = [];
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.('.product-card__media-swiper')) found.push(node);
          node.querySelectorAll?.('.product-card__media-swiper').forEach((n) => found.push(n));
        });
      });
      if (found.length) observeSliders(found);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    observeSliders(document.querySelectorAll('.product-card__media-swiper'));
    watchForNewSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
